module.exports = "pegasus/assets/custom-1-twitter.png";